import { HttpParams } from '@angular/common/http';
import { Usuario } from 'src/app/_core/models/usuario';
import { MovimentacaoService } from './../../../_core/services/movimentacao.service';
import { PageService } from './../../../_core/services/page.service';
import { Page } from './../../../_core/models/page';
import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ListagemDeInconsistenciaModalComponent } from '../listagem-de-inconsistencia-modal/listagem-de-inconsistencia-modal.component';
import { LoginService } from 'src/app/_core/services/login.service';

@Component({
  selector: 'app-listagem-de-inconsistencia',
  templateUrl: './listagem-de-inconsistencia.component.html',
  styleUrls: ['./listagem-de-inconsistencia.component.scss']
})
export class ListagemDeInconsistenciaComponent implements OnInit {
  pagina = 1;
  total = 10;
  page!: Page;
  ativo = true;
  pesquisa = '';
  loading = true;
  data:Usuario[];
  dataGestor:Usuario[];
  filtroGestor:string;
  filtroUser:string;
  keywordMatUser = 'nome';
  keywordMatGestor = 'nome';
  constructor(
    private pageService: PageService,
    private movimentacaoService: MovimentacaoService,
    private modalService: NgbModal,
    private loginService:LoginService) { }

  ngOnInit() {
    this.filtroGestor = '';
    this.filtroUser = '';
    this.ativo = true;
    this.page = new Page();
    this.page.currentPage = this.pagina;
    this.page.pageSize = this.total;
    this.page.ativo = this.ativo;
    this.page.currentPage = 1;
    this.setPage(this.page.currentPage);
    this.listarUser();
    this.listarGestor();
  }
  selectMatGestor(item:any){
    //console.log/item);
    this.filtroGestor = JSON.stringify(item.cD_MATRICULA);
    //console.log/this.filtroGestor);
    this.atualizar();
  }
  selectMatUser(item:any){
    //console.log/item);
    const params = new HttpParams({
      fromObject: {
        item
      }
    }).set("CD_CDU_MATRICULA_USUARIO_CAUTELA", item.cD_MATRICULA);
    //console.log/params);
    this.filtroUser = JSON.stringify(params.get("CD_CDU_MATRICULA_USUARIO_CAUTELA"));
    //console.log/this.filtroUser);
    this.atualizar();
  }

  listarUser(){
    this.loginService.getAuto()
    .subscribe(
      data => {
        this.data = data;
        this.data.map( data => data.nome = ` ${data.cD_MATRICULA} | ${data.nome} `)
      }
    )
  }
  listarGestor(){
    this.loginService.getGestor()
    .subscribe(
      data => {
        this.dataGestor = data;
        this.dataGestor.map( data => data.nome = ` ${data.cD_MATRICULA} | ${data.nome} `)
      }
    )
  }
  setPage(page: number): void {
    this.loading = true;
    this.page.currentPage = page;
    let params = new HttpParams();
    if(this.filtroGestor !== ''){
      params = new HttpParams();
      params = params.append('CD_CDU_MATRICULA_GESTOR', this.filtroGestor);
      
    }else if(this.filtroUser !== ''){
      params = params.append('CD_CDU_MATRICULA_USUARIO_CAUTELA', this.filtroUser);
    }
    this.movimentacaoService.mov_getInconGetAll(this.page,params)
      .subscribe(
        data => {
          this.page = data;
          this.page = this.pageService.getPager(this.page);
          this.loading = false;
        },
        err => {
          this.loading = false;
        }
      )
  }

  paginaAtual(pagina: any) {
    return this.page.currentPage === pagina;
  }

  pesquisar() {
    this.page.pesquisa = this.pesquisa;
    this.page.ativo = this.ativo;
    this.page.dados = [];
    this.setPage(1);
  }

  atualizar() {
    this.pesquisa = '';
    this.ativo = true;
    this.page.dados = [];
    this.pesquisar();
  }

  abreEdicao(nR_BPM_BEM_PATRIMONIAL: number,cD_BPM_MOVIMENTACAO_PATRIMONIAL:number) {
    const modalRef = this.modalService.open(ListagemDeInconsistenciaModalComponent, {
      size: 'xl',
      backdrop: 'static',
    });
    modalRef.componentInstance.nR_BPM_BEM_PATRIMONIAL = nR_BPM_BEM_PATRIMONIAL;
    modalRef.componentInstance.cD_BPM_MOVIMENTACAO_PATRIMONIAL = cD_BPM_MOVIMENTACAO_PATRIMONIAL;
    modalRef.result.then(() => this.atualizar());
  }

}
